import { MessageSquare } from 'lucide-react';
import { Avatar } from '../../../shared/ui/Avatar';
import { Badge } from '../../../shared/ui/Badge';
import { timeAgo } from '../../../shared/utils/timeAgo';
import {
  STATUS_LABELS, PRIORITY_LABELS, STATUS_TONE, PRIORITY_TONE, ardixReplied, lastAuthorLabel,
} from '../lib/support';
import type { SupportTicket } from '../lib/types';
import styles from '../SupportView.module.css';

interface Props {
  ticket: SupportTicket;
  unread: boolean;
  showAuthor: boolean;
  onClick: () => void;
}

export function TicketListItem({ ticket, unread, showAuthor, onClick }: Props) {
  const who = lastAuthorLabel(ticket);
  const when = timeAgo(ticket.lastMessageAt?.toMillis());
  return (
    <button
      type="button"
      className={[
        styles.item,
        // Fundo pelo MESMO tom do badge de status — mexer no STATUS_TONE move os dois
        // juntos. Tom sem classe cai no fundo padrão do .item, sem quebrar o card.
        styles[`status-${STATUS_TONE[ticket.status]}`],
        unread ? styles.itemUnread : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
    >
      <Avatar name={ticket.createdByName} size="md" />

      <div className={styles.itemMain}>
        <div className={styles.itemTop}>
          {unread ? <span className={styles.unreadDot} aria-label="não lido" /> : null}
          <span className={styles.itemSubject}>{ticket.subject}</span>
        </div>
        <div className={styles.itemMeta}>
          {showAuthor ? <span className={styles.metaAuthor}>{ticket.createdByName}</span> : null}
          {ticket.category ? <Badge tone="neutral">{ticket.category}</Badge> : null}
          <span className={styles.metaCount}>
            <MessageSquare size={13} aria-hidden /> {ticket.messageCount}
          </span>
        </div>
      </div>

      <div className={styles.itemRight}>
        <div className={styles.itemBadges}>
          {ardixReplied(ticket) ? <Badge tone="info">Ardix respondeu</Badge> : null}
          <Badge tone={STATUS_TONE[ticket.status]}>{STATUS_LABELS[ticket.status]}</Badge>
          <Badge tone={PRIORITY_TONE[ticket.priority]}>{PRIORITY_LABELS[ticket.priority]}</Badge>
        </div>
        <span className={styles.itemTime}>{who && when ? `${who} · ${when}` : when}</span>
      </div>
    </button>
  );
}
